import { ShieldAlert } from "lucide-react";

export const RestrictedView = ({ item }) => (
  <div className="max-w-xl mx-auto mt-16 bg-white border border-[#E5E7EB] border-t-4 border-t-[#E60000] rounded-lg p-10 text-center fade-up" data-testid="restricted-view">
    <ShieldAlert className="w-10 h-10 mx-auto text-[#E60000]" />
    <h2 className="font-heading text-2xl font-bold mt-4">Access restricted</h2>
    <p className="text-sm text-gray-600 mt-2">
      You don't have access to <strong>{item.label}</strong>. Ask the Super Admin to add this module to your account, or use the menu on the left to open the modules you can use.
    </p>
  </div>
);
